module.exports = __webpack_public_path__ + "static/media/stay-home.b67a553d.svg";